import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { INDUSTRY_LIST, INDUSTRIES } from "@/content/solutions";

// Home-page section: industry picker so visitors jump straight to their sector.
export function IndustriesSection() {
  return (
    <section id="industries" data-testid="home-industries" className="border-t border-border/40 py-24 sm:py-28">
      <div className="mx-auto w-full max-w-6xl px-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent">built for your stack</p>
        <h2 className="mt-3 max-w-2xl text-3xl font-semibold tracking-tight sm:text-4xl">
          Solutions for your industry.
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
          The same governed semantic layer, tuned to the questions your sector actually asks. Pick yours.
        </p>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {INDUSTRY_LIST.map((slug) => {
            const ind = INDUSTRIES[slug];
            return (
              <Link
                key={slug}
                to={`/solutions/${slug}`}
                data-testid={`home-industry-card-${slug}`}
                className="group relative flex flex-col rounded-2xl border border-border/60 bg-card/50 p-6 backdrop-blur transition-all hover:-translate-y-0.5"
                style={{ "--ind": ind.accent }}
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = `${ind.accent}66`)}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = "")}
              >
                <span
                  className="inline-flex h-11 w-11 items-center justify-center rounded-xl"
                  style={{ backgroundColor: `${ind.accent}1f`, color: ind.accent }}
                >
                  <LucideIcon name={ind.icon} className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-mono text-base font-semibold tracking-tight">{ind.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{ind.navBlurb}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.18em]"
                  style={{ color: ind.accent }}>
                  Explore <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
